<template>
  <div class="main" v-loading="loading">
    <div class="header">
      <div>
        <h2>{{ info.name||'--' }}</h2>
        <el-row>
          <el-col :span="8">
            <span>注册日期：</span>
            <span v-if="info.estiblishTime">{{ info.estiblishTime.slice(0,10) }}</span>
            <span v-else>--</span>
          </el-col>
          <el-col :span="16">
            <span>注册资本：</span>
            <span>{{ info.regCapital||'--' }}</span>
          </el-col>
        </el-row>
        <el-row class="mt-15">
          <el-col :span="8">
            <span>工商注册号：</span>
            <span>{{ info.regNumber||'--' }}</span>
          </el-col>
          <el-col :span="16">
            <span>人员规模：</span>
            <span>{{ info.staffNumRange||'--' }}</span>
          </el-col>
        </el-row>
        <el-row class="mt-15">
          <el-col :span="8">
            <span>行业：</span>
            <span :title="info.industry">{{ info.industry||'--' }}</span>
          </el-col>
          <el-col :span="16">
            <span>地址：</span>
            <span>{{ info.regLocation||'--' }}</span>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="tab">
      <a class="btn" :class="tab === 1 ? 'is-select' : ''" @click="tab = 1">公司背景</a>
      <a class="btn" :class="tab === 2 ? 'is-select' : ''" @click="tab = 2">经营信息</a>
      <a class="btn" :class="tab === 3 ? 'is-select' : ''" @click="tab = 3">知识产权</a>
      <a class="btn" :class="tab === 4 ? 'is-select' : ''" @click="tab = 4">关系图谱</a>
    </div>
    <div v-if="tab === 1" class="content">
      <company :info="info"/>
    </div>
    <div v-if="tab === 2" class="content">
      <manage />
    </div>
    <div v-if="tab === 3" class="content">
      <intellectual />
    </div>
    <div v-if="tab === 4" class="content">
      <relation :info="info"/>
    </div>
  </div>
</template>

<script>
import company from '../components/company.vue'
import manage from '../components/manage.vue'
import intellectual from '../components/intellectual.vue'
import relation from '../components/relation.vue'
import { basicInfo } from '../api/index.js'

export default {
  name: 'Enterprise',
  components: {
    company,
    manage,
    intellectual,
    relation
  },
  data () {
    return {
      tab: 1,
      loading: false,
      info: {}
    }
  },

  mounted () {
    this.basicInfo()
  },

  methods: {
    basicInfo () {
      this.loading = true

      basicInfo({ companyName: this.$route.query.name, similarValue: this.$route.query.similarValue, similarity: this.$route.query.similarity}).then(res => {
        if (!res.data) { res.data = {} }
        this.loading = false
        this.info = res.data
      }).catch(() => { this.loading = false })
    }
  }
}
</script>
<style lang='scss' scoped>
.tab{
  height: 78px;
  background: #F0F2F5;
  .btn{
    display: inline-block;
    width: 110px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    color: #333333;
    font-size: 16px;
    background: #D8DEE7;
    margin-top: 28px;
  }
  .btn+.btn{
    border-left: 2px #fff solid;
  }
  .is-select{
    background: #fff;
    color: #1890ff;
  }
}
.header{
  width: 100%;
  height: 271px;
  background:url('../../../assets/industry/header-bg.png') no-repeat ;
  background-size:100% 100%;
  color: #fff;
  >div{
    padding-top: 60px;
    padding-left: 55px;
  }
  h2{
    font-size: 24px;
    margin-bottom: 30px;
  }
  .el-col-8{
    width: 265px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .el-col-16{
    // width: 500px;
  }
}
.content{
  padding: 24px;
  background-color: #fff;
}
</style>
